import Dashboard from '../../../../../baseComponents/Dashboard'
import { getEmployeeParams } from '../../../../../utils/reducers/getters'

const StaffDashboard: React.FC = () => {
    const defaultStyle = getEmployeeParams()?.['appStyle'] || 'new1'
    const defaultWidgets = {
        default: [{ "cols": 2, "rows": 4, "name": "holiday_calendar_employees" }, { "cols": 2, "rows": 2, "name": "holiday_table_employees_week" }, { "cols": 2, "rows": 2, "name": "lastest_employee_timetable" }],
        new1: [{ "cols": 3, "rows": 5, "name": "holiday_calendar_employees" }, { "cols": 2, "rows": 3, "name": "holiday_table_employees_week" }, { "cols": 2, "rows": 2, "name": "lastest_employee_timetable" }]
    }
    
    const props = {
        name: 'dashboard_staff_distribution',
        defaultWidgets: JSON.stringify(defaultWidgets[defaultStyle])
    }
    return (<Dashboard {...props} />)
}

export default StaffDashboard